export default __webpack_public_path__ + "static/media/(8).44f715a4.jpeg";